<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large>
          mdi-history
        </v-icon>
        <h2 class="display-2">
          Änderungen
        </h2>
      </v-col>
    </v-row>

    <page-loading :is-page-loading="$store.state.pageLoading" />

    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        v-for="item in changes"
        :key="item.title"
        class="mb-6 mx-auto"
      >
        <v-card
          :class="item.class"
        >
          <v-system-bar
            status
            color="primary"
            lights-out
            dark
          >
            <span class="title font-weight-light">
              Version:
              <span class="font-weight-black mr-2">{{ item.version }}</span>
              [{{ item.date }}]
            </span>
            <v-spacer />
          </v-system-bar>
          <v-img
            :class="item.class"
            :src="item.imageSrc"
            contain
            aspect-ratio
          />
          <v-card-title>
            <h3 class="d-block display-1 font-weight-medium">
              <v-icon large dark class="mr-2">
                {{ item.icon }}
              </v-icon>
              {{ item.title }}
            </h3>
          </v-card-title>
          <v-divider dark class="mx-6" />
          <v-card-text v-html="item.text" class="headline font-weight-light white--text" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Changelog',
  metaInfo: {
    title: 'Änderungen'
  },
  data () {
    return {
      changes: []
    }
  },
  mounted: async function () {
    // load changelogs in store from cache or from server if cache is not valid
    if (await this.$store.dispatch('changelogStore/getChangelogs')) {
      this.changes = this.$store.state.changelogStore.changelogs
    }
  }
}
</script>
<style>
ul{
  margin-left: 1.5rem
}
</style>
